import React, { FC, forwardRef } from "react";
import { Control } from "react-hook-form";

import TelephoneBase from "@/components/ui/Form/Telephone/TelephoneBase";
import TelephoneControlled from "@/components/ui/Form/Telephone/TelephoneControlled";
import { TelephoneProps } from "@/types";

interface DynamicInputProps extends TelephoneProps {
  control?: Control<any>;
  defaultNumber?: string;
  showCountryName?: boolean;
}

export default function Telephone(args: DynamicInputProps) {
  return args?.control ? <TelephoneControlled control={args.control} {...args} /> : <TelephoneBase {...args} />;
}
